var e;!function(e){e.Large="large",e.Medium="medium"}(e||(e={}));export{e as Size};
